import React from "react";
import SupportFAQ from "../Models/SupportFAQ";
import QuestionAnswerDetails from "./QuestionAnswerDetails";
import {
  SupportCategoryTag,
  SupportCategoryTagWithHash,
} from "../SupportCategoryFunctions";

interface Props {
  categoryName: string;
  showCategoryNames: boolean;
  questionList: readonly SupportFAQ[];
  onClick: (id: number) => void;
  selectedQuestion: number | undefined;
}
function QuestionHeader({
  categoryName,
  showCategoryNames,
  questionList,
  onClick,
  selectedQuestion,
}: Props) {
  return (
    <div
      key={SupportCategoryTagWithHash(categoryName)}
      className={showCategoryNames ? "support-subject-group" : ""}
    >
      {showCategoryNames && (
        <p
          tabIndex={-1}
          id={SupportCategoryTag(categoryName)}
          className="support-subject"
        >
          {categoryName}
        </p>
      )}
      <QuestionAnswerDetails
        showCategoryNames={showCategoryNames}
        questionList={questionList}
        onClick={onClick}
        selectedQuestion={selectedQuestion}
      />
    </div>
  );
}

export default QuestionHeader;
